var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { useBridgeAllowTokens } from './useBridgeAllowTokens';
import { useBridgeService } from './useBridgeService';
export function useBridgeLimits(sourceChain, targetChain, asset) {
    const bridgeService = useBridgeService();
    const { data: allowTokens } = useBridgeAllowTokens(sourceChain, targetChain);
    return useQuery({
        queryKey: ['bridgeLimits', sourceChain, targetChain, asset, allowTokens],
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            try {
                return yield bridgeService.getBridgeLimits(sourceChain, targetChain, asset, allowTokens);
            }
            catch (error) {
                console.error('Error fetching bridge limits:', error);
            }
        }),
        enabled: Boolean(bridgeService && sourceChain && targetChain && asset && allowTokens),
        refetchInterval: 60000 * 10,
    });
}
